ko.bindingHandlers.loading = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const $element = $(element);
        const isButton = $element.is("button") || $element.is("a.btn") || $element.is("input.btn");
        const template = isButton ? "loaderButton" : "loaderBlock";
        const model = {
            isLoading: ko.pureComputed(function () {
                return valueAccessor()
            }),
            opacity: ko.pureComputed(function () {
                return valueAccessor() ? '0.5' : '1'
            })
        };

        if (isButton) {
            model.html = element.innerHTML;
            $element.addClass("position-relative btn-loader");
            ko.renderTemplate(template, bindingContext.createChildContext(model), { templateEngine: ko.stringTemplateEngine.instance }, element);
        } else {
            const allBindings = allBindingsAccessor();
            const options = {
                labelVisible: false,
                spinnerVisible: true,
                label: "Wird geladen, bitte warten ..."
            }
            Object.assign(model, options, allBindings.loadingOptions)
            $element.parent().addClass("position-relative");
            if (model.spinnerVisible)
                $element.parent().css("min-height", "100px");
            ko.renderTemplate(template, bindingContext.createChildContext(model), { templateEngine: ko.stringTemplateEngine.instance }, element, "replaceNode");
        }

        return { controlsDescendantBindings: true };
    },

    update: function (element, valueAccessor) {
        const $element = $(element);
        const isButton = $element.is("button") || $element.is("a.btn");
        if (isButton)
            $element.prop("disabled", ko.unwrap(valueAccessor()));
    }
};